<template>
    <div class="registration-pages" >
        <PageTitle icon="fa fa-newspaper-o" main="Registrations"
        sub="Registrations" />
        <div class="registration-pages-tabs">
            <b-card title="Card Title" small  no-body >
                <b-tabs card>
                     
                    <b-tab active>
                        <template v-slot:title>
                            <strong>Property part</strong>
                        </template>
                        <TypePartImmobile/>
                    </b-tab>
                    <b-tab>
                        <template v-slot:title>
                            <strong>Defualt Service</strong>
                        </template>
                        <DefaultServiceType/>
                    </b-tab>
                    <b-tab>
                        <template v-slot:title>
                            <strong>Day to Pay (Service)</strong>
                        </template>
                        <DaysToPayServiceProvide/>
                    </b-tab>
                         <b-tab>
                        <template v-slot:title>
                            <strong>Financial Parameter</strong>
                        </template>
                        <SystemParameter/>
                    </b-tab>
                </b-tabs>  
            </b-card>
        </div>
    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import TypePartImmobile from './TypePartImmobile'
import DefaultServiceType from './DefaultServiceType'
import DaysToPayServiceProvide from './DaysToPayServiceProvide'
import SystemParameter from './SystemParameter'


export default {
    name: 'RegistrationPages',
    components:{PageTitle,
                TypePartImmobile,
                DefaultServiceType,
                DaysToPayServiceProvide,
                SystemParameter

                }
}
</script>

<style>

 .registration-pages {
            font-size: 0.75rem;
            color: black;
        }

</style>
